import { useMemo } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FlexiForwardFormField } from '@/App/tiles/FlexiForward/FlexiForwardTile/common/form/FlexiForwardFormField.tsx';
import { SgAmountInput } from '@/components/sg-design-system/components/input/SgAmountInput';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useFlexiForwardPropertyChangedHandler } from '@/store/flexi-forward/hooks/useFlexiForwardPropertyChangedHandler.ts';

export function SolvingUpfrontField({ tileId }: { tileId: string }) {
  const { rate, tradeCapture } = useFlexiForwardSelector((flexiForward) => {
    return {
      rate: flexiForward.properties.rate ?? undefined,
      tradeCapture: flexiForward.tradeCapture,
    };
  });

  const validation = useMemo(
    () => (tradeCapture.status === 'CHECKED' ? tradeCapture?.validation : undefined),
    [tradeCapture],
  );

  const handleNumberRateChanged = useFlexiForwardPropertyChangedHandler<number | undefined>(
    tileId,
    'Rate change',
    (rate) => ({ rate }),
  );

  return (
    <FlexiForwardFormField formattedMessageId="flexiForwardTile.mainFields.rate.label">
      <TradeCaptureValidationWrapper validation={validation?.rate}>
        <SgAmountInput size="sm" onChange={handleNumberRateChanged} value={rate} data-e2e="forward-rate" />
      </TradeCaptureValidationWrapper>
    </FlexiForwardFormField>
  );
}
